import axios from 'axios'
import { getElectionsForMunicipality, getBaseUrl } from '@/lib/elections-helper'
export async function getDataFile(fileType, location, election, params) {
  const elections = getElectionsForMunicipality(location)

  const baseUrl = getBaseUrl(location, election, elections)
  try {
    const ts = new Date().getTime()
    const result = await axios.get(`${baseUrl}/${fileType}.json?${ts}`)
    return result.data
  } catch (error) {
    console.log(error) // TODO send error information somewhere maybe ?
    return null
  }
}
